import { Typography, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CustomButton from '../../../components/button/CustomButton';

const VerifyEmailSection = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <Stack width="100%" spacing={3}>
      <Typography
        variant="headline1"
        sx={{
          color: 'primaryDark.600',
        }}
      >
        {t('register.verifyYourEmail')}
      </Typography>

      <Typography
        variant="body2"
        sx={{
          color: 'primaryDark.600',
        }}
      >
        {t('register.verifyYourEmailText')}
      </Typography>

      <CustomButton
        sx={{
          maxWidth: 'fit-content',
          mt: 2,
          alignSelf: { xs: 'start', md: 'end' },
        }}
        onClick={() => navigate('/login')}
      >
        {t('common.continue')}
      </CustomButton>
    </Stack>
  );
};

export default VerifyEmailSection;
